import { render, staticRenderFns } from "./JKXKZ.vue?vue&type=template&id=36583f0a&scoped=true&"
import script from "./JKXKZ.vue?vue&type=script&lang=js&"
export * from "./JKXKZ.vue?vue&type=script&lang=js&"
import style0 from "./JKXKZ.vue?vue&type=style&index=0&id=36583f0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36583f0a",
  null
  
)

export default component.exports